// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  margin: 0 auto;
}

.module {
  border: 1px solid #ddd;
  margin-bottom: 20px;
  padding: 15px;
  border-radius: 5px;
}

.module-title {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 10px;
  color: #0056b3;
}

label {
  display: block;
  margin-bottom: 5px;
}

input[type=text],
textarea {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box; /* Ensures padding doesn't affect width */
}

input[type=file] {
  margin-bottom: 10px;
}

.step {
  margin-bottom: 15px;
}

button {
  background-color: #0056b3;
  color: white;
  padding: 10px 15px;
  border: none;
  margin-bottom: 20px;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #ffc107;
}

.navigation {
  margin-top: 20px;
  text-align: center;
}

.navigation button {
  margin: 0 5px;
}

#progress-bar-container {
  width: 100%;
  background-color: #f3f3f3;
  border-radius: 5px;
  margin-bottom: 20px;
}

#progress-bar {
  width: 20%; /* Starts at 0%, adjust based on module completed */
  height: 20px;
  background-color: #4caf50;
  text-align: center;
  line-height: 20px;
  color: white;
  border-radius: 5px;
}

.hidden {
  display: none;
}

/* .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 80px;
    background-color: #f8f9fa;
  }

  .logo-container {
    text-align: center;
    flex: 1;
  }

  .logo {
    width: 85px;
    height: 85;
    object-fit: cover;
  }

  .app-name {
    font-size: 24px;
    font-weight: bold;
    margin-top: 10px;
  } */
.user-panel {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.user-image-container {
  position: relative;
}

.user-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ccc;
}

.user-status-circle {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  background-color: green;
  border-radius: 50%;
  border: 2px solid white;
}

.logout-button {
  margin-left: 15px;
}

.logout-button .btn {
  padding: 5px 10px;
  font-size: 14px;
}

.user-panel-options {
  display: block; /* Ensures the panel is shown when isPanelVisible is true */
  position: absolute;
  top: 40px; /* Adjust the position */
  left: 0;
  background: white;
  border: 1px solid #ddd;
  padding: 10px;
  list-style: none;
}

.user-panel-options ul {
  margin: 0;
  padding: 0;
}

.user-panel-options li {
  margin: 5px 0;
}

.user-panel-options li a {
  text-decoration: none;
  color: #333;
}

.border-theme {
  color: #1c625b;
  border-color: #00a95c;
}

.user-panel-options li a:hover {
  color: #007bff;
}

/* Styling the rounded panel containing the header */
.rounded-panel {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 15px;
  padding: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  margin-top: 10px;
}

/* Vertical line before the header */
.vertical-line {
  height: 40px;
  width: 4px;
  background-color: #646464;
  margin-right: 15px;
}

/* Page title styles */
.page-title {
  font-size: 20px;
  color: #797979;
  text-align: left;
  margin: 0; /* Remove default margin */
  font-weight: 600;
}

/* Stepper Card Styling */
.card {
  border-radius: 2px;
  border: none;
  background: #ffffff;
  margin-bottom: 20px;
}

/* Wizard Header */
.wizard-header {
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-bottom: 20px;
  padding-bottom: 10px;
}

/* Progress Line */
.wizard-header::before {
  content: "";
  position: absolute;
  top: 20px;
  left: 10%;
  width: 80%;
  height: 4px;
  background: #ddd;
  z-index: 0;
}

/* Individual Steps */
.wizard-step {
  width: 150px; /* Set a fixed width */
  min-width: 150px;
  text-align: center;
  position: relative;
  z-index: 1;
  flex: 1;
  cursor: pointer;
}

/* Step Circle */
.step-circle {
  width: 40px;
  height: 40px;
  background: #ccc;
  color: #fff;
  font-weight: bold;
  font-size: 18px;
  border-radius: 50%;
  line-height: 40px;
  margin: auto;
  transition: all 0.3s ease;
}

/* Step Label */
.step-label {
  display: block;
  font-size: 14px;
  margin-top: 5px;
  font-weight: bold;
  color: #777;
}

/* Active Step Styling */
.wizard-step.active .step-circle {
  background: rgb(70, 159, 84);
}

.wizard-step.active .step-label {
  color: rgb(70, 159, 84);
}

/* Progress Line for Completed Steps */
.wizard-step.active ~ .wizard-step .step-circle {
  background: #ccc;
}

cdk-step .cdk-step-header {
  display: none !important;
}

.btn-submit {
  background-color: #00a95c;
}

.btn {
  margin-top: 20px;
  margin-right: 10px; /* Corrected margin syntax */
}

/* Autocomplete dropdown */
.autocomplete-dropdown {
  position: absolute;
  z-index: 1000;
  width: 100%;
}

.autocomplete-dropdown .list-group-item {
  cursor: pointer;
  font-size: 0.85rem;
}

.autocomplete-dropdown .list-group-item:hover {
  background-color: #f8f9fa;
}

/* Selected DCIs list */
.selected-dcis {
  background-color: #f8f9fa;
}

.selected-dcis .bg-light {
  transition: all 0.2s ease;
}

.selected-dcis .bg-light:hover {
  background-color: #e9ecef !important;
}

/* Submit button */
.btn-submit {
  background-color: #0d6efd;
  color: white;
  min-width: 150px;
}

.btn-submit:hover {
  background-color: #0b5ed7;
}

.btn-submit:disabled {
  background-color: #6c757d;
  opacity: 0.65;
}

.file-upload-container {
  position: relative;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 5px;
  transition: all 0.3s ease;
}

.file-upload-container.upload-success {
  border-color: #28a745;
}

.file-upload-container.upload-error {
  border-color: #dc3545;
}

.upload-progress {
  margin-top: 5px;
}

.upload-status {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.2rem;
}

.progress {
  height: 20px;
  margin-top: 5px;
}

.progress-bar {
  line-height: 20px;
  font-size: 12px;
}

input[type=file].form-control {
  padding-right: 2.5rem; /* room for the icon */
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/features/demandes/components/dmm-create/dmm-create.component.scss"],"names":[],"mappings":"AAAA;EAEE,cAAA;AAAF;;AAGA;EACE,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,kBAAA;AAAF;;AAGA;;EAEE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA,EAAA,yCAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,UAAA,EAAA,mDAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;KAAA;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,eAAA;AAAF;;AAGA;EACE,cAAA,EAAA,2DAAA;EACA,kBAAA;EACA,SAAA,EAAA,wBAAA;EACA,OAAA;EACA,iBAAA;EACA,sBAAA;EAEA,aAAA;EACA,gBAAA;AADF;;AAIA;EACE,SAAA;EACA,UAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,qBAAA;EACA,WAAA;AADF;;AAGA;EACE,cAAA;EACA,qBAAA;AAAF;;AAEA;EACE,cAAA;AACF;;AACA,oDAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;AAEF;;AACA,oCAAA;AACA;EACE,YAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;AAEF;;AACA,sBAAA;AACA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA,EAAA,0BAAA;EACA,gBAAA;AAEF;;AAAA,yBAAA;AACA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAGF;;AAAA,kBAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;AAGF;;AAAA,kBAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;AAGF;;AAAA,qBAAA;AACA;EACE,YAAA,EAAA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,eAAA;AAGF;;AAAA,gBAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;AAGF;;AAAA,eAAA;AACA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAGF;;AAAA,wBAAA;AACA;EACE,4BAAA;AAGF;;AAAA;EACE,uBAAA;AAGF;;AAAA,sCAAA;AACA;EACE,gBAAA;AAGF;;AADA;EACE,wBAAA;AAIF;;AADA;EACE,yBAAA;AAIF;;AADA;EACE,gBAAA;EACA,kBAAA,EAAA,4BAAA;AAIF;;AAFA,0BAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;AAKF;;AAFA;EACE,eAAA;EACA,kBAAA;AAKF;;AAFA;EACE,yBAAA;AAKF;;AAFA,uBAAA;AACA;EACE,yBAAA;AAKF;;AAFA;EACE,yBAAA;AAKF;;AAFA;EACE,oCAAA;AAKF;;AAFA,kBAAA;AACA;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;AAKF;;AAFA;EACE,yBAAA;AAKF;;AAFA;EACE,yBAAA;EACA,aAAA;AAKF;;AAHA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AAMF;;AAHA;EACE,qBAAA;AAMF;;AAHA;EACE,qBAAA;AAMF;;AAHA;EACE,eAAA;AAMF;;AAHA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,iBAAA;AAMF;;AAHA;EACE,YAAA;EACA,eAAA;AAMF;;AAHA;EACE,iBAAA;EACA,eAAA;AAMF;;AAJA;EACE,qBAAA,EAAA,sBAAA;AAOF;AACA,g1YAAg1Y","sourcesContent":[".container {\n  // max-width: 600px;\n  margin: 0 auto;\n}\n\n.module {\n  border: 1px solid #ddd;\n  margin-bottom: 20px;\n  padding: 15px;\n  border-radius: 5px;\n}\n\n.module-title {\n  font-size: 1.2em;\n  font-weight: bold;\n  margin-bottom: 10px;\n  color: #0056b3;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 5px;\n}\n\ninput[type=\"text\"],\ntextarea {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box; /* Ensures padding doesn't affect width */\n}\n\ninput[type=\"file\"] {\n  margin-bottom: 10px;\n}\n\n.step {\n  margin-bottom: 15px;\n}\n\nbutton {\n  background-color: #0056b3;\n  color: white;\n  padding: 10px 15px;\n  border: none;\n  margin-bottom: 20px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\nbutton:hover {\n  background-color: #ffc107;\n}\n\n.navigation {\n  margin-top: 20px;\n  text-align: center;\n}\n\n.navigation button {\n  margin: 0 5px;\n}\n#progress-bar-container {\n  width: 100%;\n  background-color: #f3f3f3;\n  border-radius: 5px;\n  margin-bottom: 20px;\n}\n\n#progress-bar {\n  width: 20%; /* Starts at 0%, adjust based on module completed */\n  height: 20px;\n  background-color: #4caf50;\n  text-align: center;\n  line-height: 20px;\n  color: white;\n  border-radius: 5px;\n}\n\n.hidden {\n  display: none;\n}\n\n/* .header-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 80px;\n    background-color: #f8f9fa;\n  }\n  \n  .logo-container {\n    text-align: center;\n    flex: 1;\n  }\n  \n  .logo {\n    width: 85px;\n    height: 85;\n    object-fit: cover;\n  }\n  \n  .app-name {\n    font-size: 24px;\n    font-weight: bold;\n    margin-top: 10px;\n  } */\n\n.user-panel {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.user-image-container {\n  position: relative;\n}\n\n.user-image {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid #ccc;\n}\n\n.user-status-circle {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 10px;\n  height: 10px;\n  background-color: green;\n  border-radius: 50%;\n  border: 2px solid white;\n}\n\n.logout-button {\n  margin-left: 15px;\n}\n\n.logout-button .btn {\n  padding: 5px 10px;\n  font-size: 14px;\n}\n\n.user-panel-options {\n  display: block; /* Ensures the panel is shown when isPanelVisible is true */\n  position: absolute;\n  top: 40px; /* Adjust the position */\n  left: 0;\n  background: white;\n  border: 1px solid #ddd;\n  // box-shadow: 0 0 10px rgba(255, 255, 255, 0.1);\n  padding: 10px;\n  list-style: none;\n}\n\n.user-panel-options ul {\n  margin: 0;\n  padding: 0;\n}\n\n.user-panel-options li {\n  margin: 5px 0;\n}\n\n.user-panel-options li a {\n  text-decoration: none;\n  color: #333;\n}\n.border-theme {\n  color: #1c625b;\n  border-color: #00a95c;\n}\n.user-panel-options li a:hover {\n  color: #007bff;\n}\n/* Styling the rounded panel containing the header */\n.rounded-panel {\n  display: flex;\n  align-items: center;\n  background-color: #f5f5f5;\n  border-radius: 15px;\n  padding: 15px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 10px;\n  margin-top: 10px;\n}\n\n/* Vertical line before the header */\n.vertical-line {\n  height: 40px;\n  width: 4px;\n  background-color: #646464;\n  margin-right: 15px;\n}\n\n/* Page title styles */\n.page-title {\n  font-size: 20px;\n  color: #797979;\n  text-align: left;\n  margin: 0; /* Remove default margin */\n  font-weight: 600;\n}\n/* Stepper Card Styling */\n.card {\n  border-radius: 2px;\n  border: none;\n  background: #ffffff;\n  margin-bottom: 20px;\n}\n\n/* Wizard Header */\n.wizard-header {\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n}\n\n/* Progress Line */\n.wizard-header::before {\n  content: \"\";\n  position: absolute;\n  top: 20px;\n  left: 10%;\n  width: 80%;\n  height: 4px;\n  background: #ddd;\n  z-index: 0;\n}\n\n/* Individual Steps */\n.wizard-step {\n  width: 150px; /* Set a fixed width */\n  min-width: 150px;\n  text-align: center;\n  position: relative;\n  z-index: 1;\n  flex: 1;\n  cursor: pointer;\n}\n\n/* Step Circle */\n.step-circle {\n  width: 40px;\n  height: 40px;\n  background: #ccc;\n  color: #fff;\n  font-weight: bold;\n  font-size: 18px;\n  border-radius: 50%;\n  line-height: 40px;\n  margin: auto;\n  transition: all 0.3s ease;\n}\n\n/* Step Label */\n.step-label {\n  display: block;\n  font-size: 14px;\n  margin-top: 5px;\n  font-weight: bold;\n  color: #777;\n}\n\n/* Active Step Styling */\n.wizard-step.active .step-circle {\n  background: rgb(70, 159, 84);\n}\n\n.wizard-step.active .step-label {\n  color: rgb(70, 159, 84);\n}\n\n/* Progress Line for Completed Steps */\n.wizard-step.active ~ .wizard-step .step-circle {\n  background: #ccc;\n}\ncdk-step .cdk-step-header {\n  display: none !important;\n}\n\n.btn-submit {\n  background-color: #00a95c;\n}\n\n.btn {\n  margin-top: 20px;\n  margin-right: 10px; /* Corrected margin syntax */\n}\n/* Autocomplete dropdown */\n.autocomplete-dropdown {\n  position: absolute;\n  z-index: 1000;\n  width: 100%;\n}\n\n.autocomplete-dropdown .list-group-item {\n  cursor: pointer;\n  font-size: 0.85rem;\n}\n\n.autocomplete-dropdown .list-group-item:hover {\n  background-color: #f8f9fa;\n}\n\n/* Selected DCIs list */\n.selected-dcis {\n  background-color: #f8f9fa;\n}\n\n.selected-dcis .bg-light {\n  transition: all 0.2s ease;\n}\n\n.selected-dcis .bg-light:hover {\n  background-color: #e9ecef !important;\n}\n\n/* Submit button */\n.btn-submit {\n  background-color: #0d6efd;\n  color: white;\n  min-width: 150px;\n}\n\n.btn-submit:hover {\n  background-color: #0b5ed7;\n}\n\n.btn-submit:disabled {\n  background-color: #6c757d;\n  opacity: 0.65;\n}\n.file-upload-container {\n  position: relative;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  padding: 5px;\n  transition: all 0.3s ease;\n}\n\n.file-upload-container.upload-success {\n  border-color: #28a745;\n}\n\n.file-upload-container.upload-error {\n  border-color: #dc3545;\n}\n\n.upload-progress {\n  margin-top: 5px;\n}\n\n.upload-status {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 1.2rem;\n}\n\n.progress {\n  height: 20px;\n  margin-top: 5px;\n}\n\n.progress-bar {\n  line-height: 20px;\n  font-size: 12px;\n}\ninput[type=\"file\"].form-control {\n  padding-right: 2.5rem; /* room for the icon */\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
